export default __webpack_public_path__ + "static/media/calendar.26e93a37.svg";